import React, { useEffect } from 'react';
import { IconFaceFrownFill, IconFaceSmileFill } from '@arco-design/web-react/icon';
import useWcag from '../../base/color/config/useWcag';
import useLocale from '@src/hooks/useLocale';
import locale from './locale';
var Wcag = function Wcag(props) {
  var front = props.front,
    background = props.backgroundColor;
  var _a = useWcag({
      front: front,
      background: background
    }),
    contrast = _a.contrast,
    setFront = _a.setFront,
    setBackground = _a.setBackground;
  var t = useLocale(locale).t;
  useEffect(function () {
    setFront(front);
    setBackground(background);
  }, [front, background]);
  return /*#__PURE__*/React.createElement("div", {
    className: "inspector-wcag-wrapper"
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", {
    className: "wcag-label"
  }, t['inspector.wcag']), /*#__PURE__*/React.createElement("span", {
    className: "wcag-result " + (Number(contrast) >= 3 ? 'wcag-result-success' : 'wcag-result-fail') + " "
  }, Number(contrast) >= 3 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconFaceSmileFill, null), t['inspector.pass']) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconFaceFrownFill, null), t['inspector.notPass']))), /*#__PURE__*/React.createElement("span", {
    className: "wcag-value-box"
  }, /*#__PURE__*/React.createElement("span", {
    className: "wcag-value-icon"
  }, "Aa"), /*#__PURE__*/React.createElement("span", {
    className: "wcag-value"
  }, contrast)));
};
export default Wcag;